export interface ISakStatusItems {
    sakstatusId?: string;
    navn?: string;
    kode?: string;
    system?: string;
}

export interface ISakStatusCount {
    statusName?: string;
    statusCode?: string;
    statusId?: string;
    statusCount: 0;
}

export class SakStatusSummary {
    statusSummary: { [key: string]: number } = {};
}
